module.exports = __webpack_public_path__ + "Roboto-Thin.2f1c68f7e82736f91049.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/assets/font/roboto/Roboto-Thin.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Thin.woff
// module chunks = 2